import { DatatableComponent } from "@swimlane/ngx-datatable";
import { Router, NavigationExtras } from "@angular/router";
import { LoadingService } from "./../../../util/loader.service";
import { ActivatedRoute } from "@angular/router";
import { saveAs } from 'file-saver';
const b64toBlob = require('b64-to-blob');
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Injector
} from "@angular/core";
import { ClienteService } from "./cliente.service";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { ModalEditarClienteComponent } from "./modal-editar-cliente/modal-editar-cliente.component";

const swal = require("sweetalert");


@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss'],
  animations: [
    trigger('filterBlur', [
      state(
        'hide',
        style({
          opacity: 1
        })
      ),
      state(
        'show',
        style({
          opacity: 0
        })
      ),
      transition('hide => show', animate('200ms ease-in')),
      transition('show => hide', animate('200ms ease-out'))
    ])
  ]
})
export class ClientesComponent implements OnInit {

  rows: Object[];
  selectCheck;
  selected = [];
  registroSelecao = [];
  parametroConsulta: string;
  filterState: boolean = true;
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: "",
    ativo: true
  };
  mesagensGrid = {
    emptyMessage: "Nenhum dado para exibir",
    totalMessage: "Total de registros",
    selectedMessage: "Selecionado"
  };
  acoesBottoes: boolean = true;
  sortDir: string = "";
  sortProp: string = "";
  @ViewChild('tableClientes') table: any;
  blur = false;
  public modalRef: BsModalRef;


  ngOnDestroy(): void { }

  constructor(
    public service: ClienteService,
    public injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
    public loader: LoadingService,
    private modalService: BsModalService
  ) {
    this.reloadTable();
    this.parametroConsulta = "";
  }
  limparConsultaRapida() {
    this.page.descricao = "";
    this.parametroConsulta = "";
    this.page.offset = 0;
    this.page.limit = 10;
    this.reloadTable();
  }
  consultaRapida(event) {
    if (event.keyCode == 13 && this.parametroConsulta.length >= 3) {
      this.page.descricao = this.parametroConsulta.trim();
      this.page.offset = 0;
      this.limparSelecionados();
      this.reloadTable();
    }
  }
  obterInformacoes() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "data": JSON.stringify(this.registroSelecao[0]),
        },
        skipLocationChange: true
      };
      this.router.navigate(['/fidel/cliente/informacoes'], navigationExtras);
    }
  }

  exportar(event) {
    this.loader.show("body");
    this.service.exportar().subscribe(itens => {
      this.loader.hide("body");
      let EXCEL_EXTENSION = '.xlsx';
      saveAs(itens, 'meus_clientes' + EXCEL_EXTENSION);

    });
  }
  editar(event) {

    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.loader.show("body");
      this.service.detalhar(this.registroSelecao[0].id_usuarios).subscribe(itens => {

        this.loader.hide("body");

        const config: ModalOptions = {
          backdrop: 'static',
          keyboard: false,
          animated: true,
          class: 'modal-lg',
          // size: 'lg', // sm, md, lg
          ignoreBackdropClick: true,
          initialState: {
            cliente: itens
          }
        };
        this.modalRef = this.modalService.show(ModalEditarClienteComponent, config);

        this.modalRef.content.onClose.subscribe(result => {
          this.limparSelecionados();
          this.reloadTable();


        });
      });
    }

  }
  reloadTable() {
    this.loader.show("body");
    this.service.obterTodos(this.page, this.sortDir, this.sortProp).subscribe(itens => {
      this.loader.hide("body");
      this.page.count = itens.count;
      this.rows = itens.rows;
    });
  }

  filtro(event) {
    this.page.descricao = this.parametroConsulta;
    this.reloadTable();
  }

  onFilterChange(eve: any) {
    this.page.ativo = eve;
    this.reloadTable();
  }

  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.registroSelecao = [];
    this.selected = [];
    this.reloadTable();
  }



  linkNovo() {
    this.router.navigate(["/fidel/notificacao/novo"]);
  }

  ngOnInit() { }

  onSort(event) {
    this.sortDir = event.sorts[0].dir;
    this.sortProp = event.sorts[0].prop;
    this.page.offset = 0;
    this.reloadTable();
  }

  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];
    this.acoesBottoes = true;

    this.onSelect({ selected: [] });
    this.table.selected = [];

    var inputs = document.getElementsByTagName('input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('type') == 'checkbox') {
        inputs[i].checked = false;
      }
    }
  }
  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.id_empresa == codigo) {
        x = true;
      }
    });
    return x;
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].id_usuarios == item[0].id_usuarios) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }


  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }

  ativarFiltros($event) {
    this.blur = !this.blur;
  }
}
